<div class="popup" *ngIf="isPopupVisible">
    <div class="popup-header">
        <button class="close-btn" (click)="closePopup()">X</button>
    </div>
    <div>
        <p>Do you wish to complete or redo the process?</p>
    </div>
    <div class="popup-body">
        <button class="action-btn redo-btn" (click)="redoAction()">Redo</button>
        <button class="action-btn complete-btn" (click)="completeAction()">Complete</button>
    </div>
    <transflo-document-metadata [metadata]="documentMetadata" [documentName]="documentName" [showPopup]="showPopup"
        [eventId]="eventId" (close)="onClosePopup()" (submit)="onSubmitForm($event)">
    </transflo-document-metadata>
</div>